import PropTypes from 'prop-types';

export default {
	accountName: PropTypes.string,
	accountNumber: PropTypes.string,
	sortCode: PropTypes.string,
	accountType: PropTypes.string,
	beneficiaryId: PropTypes.string,
	reference: PropTypes.string,

	customerId: PropTypes.string,
	customerType: PropTypes.string,
};

// {
// 	customer: {
// 		customer_id: '1012345678',
// 		customer_segment: 'retail', //This will be either retail (encompassing personal and private) or business
// 	},
// 	beneficiary: {
// 		beneficiary_uuid: '87cd1cc3-e8db-4431-b136-caa98a44a6a2', //Optional
// 	},
// 	AccountNameVerification: {
// 		Data: {
// 			SchemeName: 'SortCodeAccountNumber', //The identification scheme. Always "SortCodeAccountNumber"
// 			AccountType: 'Business', //The type of account ('Personal' or 'Business') as selected by the payer.
// 			Identification: 'string', //The sort code and account number of the payee as entered by the payer. Pattern: ^[0-9]{14}$
// 			Name: 'string', //The account name of the payee as entered by the payer. Max length 140 characters.
// 			SecondaryIdentification: 'string', //The beneficiary reference information as input by the payer. Max length 140 characters.
// 		},
// 	},
